import { useState } from 'react';
import { useUser } from '../contexts/UserContext';

const Register = ({ onSwitchToLogin, onRegisterSuccess }) => {
  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    pseudonym: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false,
    acceptPrivacy: false,
    referralCode: new URLSearchParams(window.location.search).get('ref') || ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { signup } = useUser();

  function handleChange(e) {
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (loading) return;

    if (formData.password !== formData.confirmPassword) {
      return setError('Les mots de passe ne correspondent pas');
    }

    if (formData.pseudonym.length < 3) {
      return setError('Le pseudonyme doit contenir au moins 3 caractères');
    }

    if (!formData.lastName || !formData.firstName) {
      return setError('Le nom et le prénom sont requis');
    }

    if (!formData.acceptTerms || !formData.acceptPrivacy) {
      return setError(
        "Vous devez accepter les conditions d'utilisation et la politique de confidentialité"
      );
    }

    try {
      setError('');
      setLoading(true);
      await signup(
        formData.email, 
        formData.password, 
        formData.pseudonym,
        formData.lastName,
        formData.firstName,
        formData.acceptTerms,
        formData.acceptPrivacy,
        formData.referralCode
      );
      if (onRegisterSuccess) onRegisterSuccess();
    } catch (err) {
      setError(err.message || 'Échec de la création du compte.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="cb-auth-page">
      <div className="cb-auth-panel">
        <div className="cb-auth-mark" aria-hidden="true">CB</div>
        <h2 className="text-center">Démarrez votre préparation</h2>
        <p className="cb-auth-intro">
          Créez votre espace personnel pour retrouver vos entraînements et suivre vos progrès.
        </p>

        {error && (
          <div role="alert" className="cb-auth-error">{error}</div>
        )}

        <form className="cb-auth-form" onSubmit={handleSubmit} aria-busy={loading}>
          <div className="cb-auth-fields">
            <p className="cb-auth-section-title">Vos informations</p>
            <div className="cb-auth-name-grid">
              <div className="cb-auth-field">
                <label htmlFor="cb-register-last-name">Nom</label>
                <input
                  className="text-primary"
                  id="cb-register-last-name"
                  type="text"
                  name="lastName"
                  autoComplete="family-name"
                  required
                  placeholder="Votre nom"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <div className="cb-auth-field">
                <label htmlFor="cb-register-first-name">Prénom</label>
                <input
                  className="text-primary"
                  id="cb-register-first-name"
                  type="text"
                  name="firstName"
                  autoComplete="given-name"
                  required
                  placeholder="Votre prénom"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="cb-auth-field">
              <label htmlFor="cb-register-pseudonym">Pseudonyme</label>
              <input
                className="text-primary"
                id="cb-register-pseudonym"
                type="text"
                name="pseudonym"
                autoComplete="nickname"
                required
                placeholder="Choisissez un pseudonyme"
                aria-describedby="cb-register-pseudonym-hint"
                value={formData.pseudonym}
                onChange={handleChange}
                maxLength={20}
              />
              <p id="cb-register-pseudonym-hint" className="cb-auth-hint">
                Ce nom sera visible sur le forum. Entre 3 et 20 caractères.
              </p>
            </div>

            <div className="cb-auth-field">
              <label htmlFor="cb-register-email">Adresse e-mail</label>
              <input
                className="text-primary"
                id="cb-register-email"
                type="email"
                name="email"
                autoComplete="email"
                required
                placeholder="vous@exemple.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="cb-auth-field">
              <label htmlFor="cb-register-referral">Code de parrainage (facultatif)</label>
              <input className="text-primary" id="cb-register-referral" type="text"
                name="referralCode" autoComplete="off" maxLength={20}
                placeholder="Ex. BF-AB12CD34EF56"
                aria-describedby="cb-register-referral-hint"
                value={formData.referralCode} onChange={handleChange} />
              <p id="cb-register-referral-hint" className="cb-auth-hint">
                Si vous avez ouvert un lien d’invitation, le code apparaît automatiquement.
              </p>
            </div>

            <div className="cb-auth-field">
              <label htmlFor="cb-register-password">Mot de passe</label>
              <input
                className="text-primary"
                id="cb-register-password"
                type="password"
                name="password"
                autoComplete="new-password"
                required
                minLength={6}
                placeholder="Créez un mot de passe"
                aria-describedby="cb-register-password-hint"
                value={formData.password}
                onChange={handleChange}
              />
              <p id="cb-register-password-hint" className="cb-auth-hint">
                6 caractères minimum.
              </p>
            </div>

            <div className="cb-auth-field">
              <label htmlFor="cb-register-confirm-password">Confirmer le mot de passe</label>
              <input
                className="text-primary"
                id="cb-register-confirm-password"
                type="password"
                name="confirmPassword"
                autoComplete="new-password"
                required
                placeholder="Saisissez à nouveau le mot de passe"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="cb-auth-legal">
            <label>
              <input
                className="text-primary"
                type="checkbox"
                name="acceptTerms"
                checked={formData.acceptTerms}
                onChange={handleChange}
                required
              />
              <span>J’accepte les conditions d’utilisation de ConcoursBF.</span>
            </label>
            <label>
              <input
                className="text-primary"
                type="checkbox"
                name="acceptPrivacy"
                checked={formData.acceptPrivacy}
                onChange={handleChange}
                required
              />
              <span>
                J’accepte la politique de confidentialité et le traitement des
                données nécessaires au fonctionnement de mon compte.
              </span>
            </label>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Inscription en cours...' : 'Créer mon compte'}
          </button>
        </form>
        <p className="cb-auth-switch">
          Vous avez déjà un compte ?
          <button type="button" onClick={onSwitchToLogin}>Se connecter</button>
        </p>
      </div>
    </div>
  );
};

export default Register;
